/** Primary key for gift card / prepurchased-license rows (API may use any of these). */
export const getGiftCardRowId = (record) =>
  record?.GiftCardNo ??
  record?.PrepurchasedLicenseNo ??
  record?.PurchaseNo ??
  record?.id;
